function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from 'react';
import { validCheck } from '../index';
export var useSort = function useSort(_ref) {
  var sorter = _ref.sorter,
      columns = _ref.columns,
      datasource = _ref.datasource;

  var _useState = useState(datasource !== null && datasource !== void 0 ? datasource : []),
      _useState2 = _slicedToArray(_useState, 2),
      sortedDts = _useState2[0],
      setSortedDts = _useState2[1];

  var _useState3 = useState(sorter || []),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSorter = _useState4[0],
      setCurrentSorter = _useState4[1];

  useEffect(function () {
    if (!validCheck(columns) || !validCheck(datasource) || !validCheck(currentSorter)) {
      return setSortedDts(datasource !== null && datasource !== void 0 ? datasource : []);
    }

    var _currentSorter$ = currentSorter[0],
        column = _currentSorter$.column,
        order = _currentSorter$.order;

    if (!order) {
      return setSortedDts(datasource);
    }

    var sortFn = null;

    var _iterator = _createForOfIteratorHelper(columns),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var col = _step.value;
        var _sorter = col.sorter,
            sortDirections = col.sortDirections,
            key = col.key;

        if (key === column && sortDirections && typeof _sorter === 'function') {
          sortFn = _sorter;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (sortFn) {
      var result = _toConsumableArray(datasource).sort(sortFn);

      order === 'descend' && result.reverse();
      return setSortedDts(result);
    }

    setSortedDts(datasource);
  }, [datasource, columns, currentSorter]);
  useEffect(function () {
    if (sorter) {
      setCurrentSorter(sorter);
      return;
    }

    var _iterator2 = _createForOfIteratorHelper(columns),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _step2.value,
            defaultOrder = _step2$value.defaultOrder,
            sorterFn = _step2$value.sorter,
            sortDirections = _step2$value.sortDirections,
            key = _step2$value.key;

        if (defaultOrder && sorterFn && (sortDirections === null || sortDirections === void 0 ? void 0 : sortDirections.includes(defaultOrder))) {
          setCurrentSorter([{
            column: key,
            order: defaultOrder
          }]);
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }, [sorter, columns]);
  return {
    sortedDts: sortedDts,
    currentSorter: currentSorter,
    setCurrentSorter: setCurrentSorter
  };
};